"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaffExcessOptionsDetails = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excessHelper = require("../../helpers/excessHelper");
var _tableContext = require("../productsTable/stateHelpers/tableContext");
var _staffModeHelpers = require("./staffModeHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StaffExcessOptionsDetails = exports.StaffExcessOptionsDetails = function StaffExcessOptionsDetails(_ref) {
  var plan = _ref.plan;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    _useContext$tableCont = _useContext.tableContext,
    AddOnsMap = _useContext$tableCont.AddOnsMap,
    AllPlans = _useContext$tableCont.AllPlans,
    _useContext$tableStat = _useContext.tableState,
    staffMode = _useContext$tableStat.staffMode,
    petSureStaffMode = _useContext$tableStat.petSureStaffMode;
  var planNumber = plan.planNumber,
    externalName = plan.externalName;
  var allExcessOptions = (0, _excessHelper.FindAllExcessOptionsBasedOnAmount)({
    planNumber: planNumber,
    staffMode: staffMode,
    petSureStaffMode: petSureStaffMode,
    AddOnsMap: AddOnsMap,
    AllPlans: AllPlans
  }).sort(function (a, b) {
    if (a.value < b.value) {
      return -1;
    }
    return 1;
  });
  if (allExcessOptions.length <= 1) {
    if (allExcessOptions[0].value === 0) {
      return /*#__PURE__*/_react["default"].createElement("p", {
        className: "staffScriptItem"
      }, /*#__PURE__*/_react["default"].createElement("strong", null, externalName), " has no excess.");
    }
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "staffScriptItem"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, externalName), " includes an annual excess of ", allExcessOptions[0].label);
  }
  if (allExcessOptions.length === 2) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "staffScriptItem"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, externalName, " "), "We also offer a ", allExcessOptions[1].label, " excess option that can reduce your premiums.", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
      className: "highAccuracy"
    }, "Would you like to apply an excess to your cover?"));
  }
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: "staffScriptItem"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "For ", externalName, ": "), "We also offer ", (0, _staffModeHelpers.JoinWordsTogether)({
    wordsArray: allExcessOptions.splice(1).map(function (excessOption) {
      return "$".concat(excessOption.label);
    }),
    joiningWord: 'or ',
    midSentence: true
  }), " excess options that can reduce your premiums.", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
    className: "highAccuracy"
  }, "Would you like to apply an excess to your cover?"));
};

// TODO: Swap out once this propType is properly defined.
StaffExcessOptionsDetails.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  plan: _propTypes["default"].any
};